import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { Card } from "@/components/ui/card";
import { Badge } from "@/components/ui/badge";
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from "@/components/ui/table";

export default function AdminWebhooks() {
  const [events, setEvents] = useState([]);
  useEffect(() => { api.get("/admin/webhooks").then((r) => setEvents(r.data)); }, []);

  return (
    <div className="space-y-4" data-testid="admin-webhooks">
      <h1 className="text-3xl font-display font-semibold">سجل Webhooks</h1>
      <Card className="bg-white border-foreground/10">
        <Table>
          <TableHeader>
            <TableRow className="border-foreground/10 hover:bg-transparent">
              <TableHead className="text-foreground">المصدر</TableHead>
              <TableHead className="text-foreground">النوع</TableHead>
              <TableHead className="text-foreground">ID خارجي</TableHead>
              <TableHead className="text-foreground">التوقيع</TableHead>
              <TableHead className="text-foreground">الحالة</TableHead>
              <TableHead className="text-foreground">التاريخ</TableHead>
            </TableRow>
          </TableHeader>
          <TableBody>
            {events.map((e) => (
              <TableRow key={e.id} className="border-foreground/10">
                <TableCell><Badge variant="outline">{e.source}</Badge></TableCell>
                <TableCell className="text-xs">{e.event_type}</TableCell>
                <TableCell className="font-mono text-xs">{(e.external_id || "").slice(0, 24)}</TableCell>
                <TableCell>{e.signature_verified ? "✓" : "—"}</TableCell>
                <TableCell><Badge variant={e.status === "ok" ? "default" : e.status === "error" ? "destructive" : "secondary"}>{e.status}</Badge></TableCell>
                <TableCell className="text-xs">{e.received_at?.slice(0, 16).replace("T", " ")}</TableCell>
              </TableRow>
            ))}
            {events.length === 0 && <TableRow><TableCell colSpan={6} className="text-center opacity-60 py-8">لم يستقبل أي حدث بعد. جميع الأحداث تأتي من Stripe عبر <code>POST /api/webhooks/stripe</code>.</TableCell></TableRow>}
          </TableBody>
        </Table>
      </Card>
    </div>
  );
}
